




































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Ref, Vue } from 'vue-property-decorator';

@Component
export default class ComponentsDrawer extends Vue {
  @Ref('drawer') private rdrawer!: HTMLFormElement;

  private DESTINATIONS: object = {
    primary: [
      {
        icon: 'mail',
        label: 'Inbox'
      },
      {
        icon: 'send',
        label: 'Outbox'
      },
      {
        icon: 'favorite',
        label: 'Favorites'
      },
      {
        icon: 'archive',
        label: 'Archive'
      },
      {
        icon: 'delete',
        label: 'Trash'
      },
      {
        icon: 'report',
        label: 'Spam'
      }
    ],
    secondary: [
      {
        icon: 'bookmark',
        label: 'Family'
      },
      {
        icon: 'bookmark',
        label: 'Friends'
      },
      {
        icon: 'bookmark',
        label: 'Work'
      }
    ],
    unrelated: [
      {
        icon: 'settings',
        label: 'Settings & account'
      },
      {
        icon: 'feedback',
        label: 'Help & feedback'
      }
    ]
  };

  private vlabel = 'Inbox';
  private vactive0 = true;
  private vactive1 = true;
  private vactive2 = true;

  private ftoggleActive(): void {
    this.rdrawer.ftoggle();
  }

  private fbeforeOpen(): void {
    console.log('Drawer will be opened');
  }

  private fbeforeClose(): void {
    console.log('Drawer will be closed');
  }
}
